if (!globalThis.webpackPublicPath) {
  alert('window.webpackPublicPath not defined');
}

// Set the base URL (asset host) for all webpack related requests.
// This must run before any other module imports assets.
// eslint-disable-next-line no-undef
__webpack_public_path__ = globalThis.webpackPublicPath;
